import { render } from "./AttributeTags.vue?vue&type=template&id=82cfb622&scoped=true"
import script from "./AttributeTags.vue?vue&type=script&lang=js"
export * from "./AttributeTags.vue?vue&type=script&lang=js"

import "./AttributeTags.vue?vue&type=style&index=0&id=82cfb622&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82cfb622"]])

export default __exports__